import { AnalyteConfig } from '@app/data/interface/widget-config';

// export const color = [
//   '#f26b4b', // Orange
//   '#0582bf', // Dark blue
//   '#8c7ebb', // Light purple
//   '#00a7ca', // Mid teal
//   '#473b7b', // Dark purple
//   '#66c39b', // Mid green
//   '#82afdd', // Mid cornflower
//   '#c83c7b', // Dark magenta
//   '#86cdae', // Light green
//   '#007093', // Dark teal
//   '#a8ceee', // Light cornflower
//   '#26312b', // Charcoal
//   '#00916f', // Dark green
//   '#615097', // Mid purple
//   '#00b1d8', // Light blue
//   '#5fc9de', // Light teal
//   '#ee4891', // Mid magenta
//   '#6894cd', // Dark cornflower
//   '#0395ca', // Mid blue
// ];

export const masterAnalytes: Record<string, AnalyteConfig> = {
  'dissolved-oxygen-in-field': {
    analyte: 'dissolved-oxygen-in-field',
    name: 'Dissolved Oxygen',
    unit: 'g/m³',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  'water-temperature': {
    analyte: 'water-temperature',
    name: 'Temp',
    unit: 'C',
    default: true,
    color: '#00b1d8',
  } as AnalyteConfig,
  'ph-in-lab': {
    analyte: 'ph-in-lab',
    name: 'PH in Lab',
    unit: 'no unit', // pH is unitless but this is used to match between labels on axies
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'ph-in-field': {
    analyte: 'ph-in-field',
    name: 'pH in Field',
    unit: 'pH',
    default: true,
    color: '#b95038',
  } as AnalyteConfig,
  turbidity: {
    analyte: 'turbidity',
    name: 'Turbidity',
    unit: 'NTU',
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'turbidity-fnu': {
    analyte: 'turbidity-fnu',
    name: 'Turbidity',
    unit: 'FNU',
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'setchi-disk': {
    analyte: 'setchi-disk',
    name: 'Black Disk',
    unit: 'cm',
    default: true,
    color: '#26312b',
  } as AnalyteConfig,
  'enterococci-bacteria': {
    analyte: 'enterococci-bacteria',
    name: 'Enterococci Bacteria',
    unit: 'cfu/100ml',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  'dissolved-oxygen-mg-per-litre': {
    analyte: 'dissolved-oxygen-mg-per-litre',
    name: 'Dissolved Oxygen',
    unit: 'mg/L',
    default: true,
    color: '#26312b',
  } as AnalyteConfig,
  'total-phosphorus': {
    analyte: 'total-phosphorus',
    name: 'Total Phosphorus',
    unit: 'g/m³',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  'total-kjeldahl-nitrogen': {
    analyte: 'total-kjeldahl-nitrogen',
    name: 'Total Nitrogen',
    unit: 'g/m³',
    default: true,
    color: '#f2a900',
  } as AnalyteConfig,
  'chemical-oxygen-demand': {
    analyte: 'chemical-oxygen-demand',
    name: 'COD as O2',
    unit: 'g/m³',
    default: true,
    color: '#00b1d8',
  } as AnalyteConfig,
  'electrical-conductivity-in-lab': {
    analyte: 'electrical-conductivity-in-lab',
    name: 'Electrical Conductivity (lab)',
    unit: 'mS/m',
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'sample-temperature-c': {
    analyte: 'sample-temperature-c',
    name: 'Sample Temperature',
    unit: '°C',
    default: true,
    color: '#26312b',
  } as AnalyteConfig,
  'total-alkalinity': {
    analyte: 'total-alkalinity',
    name: 'Alkalinity',
    unit: 'g/m³',
    default: true,
    color: '#00b1d8',
  } as AnalyteConfig,
  'dissolved-arsenic': {
    analyte: 'dissolved-arsenic',
    name: 'Arsenic',
    unit: 'g/m³',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  'dissolved-copper': {
    analyte: 'dissolved-copper',
    name: 'Copper',
    unit: 'g/m³',
    default: true,
    color: '#f2a900',
  } as AnalyteConfig,
  'dissolved-iron': {
    analyte: 'dissolved-iron',
    name: 'Iron',
    unit: 'g/m³',
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'dissolved-lead': {
    analyte: 'dissolved-lead',
    name: 'Lead',
    unit: 'g/m³',
    default: true,
    color: '#26312b',
  } as AnalyteConfig,
  'dissolved-zinc': {
    analyte: 'dissolved-zinc',
    name: 'Zinc',
    unit: 'g/m³',
    default: true,
    color: '#00b1d8',
  } as AnalyteConfig,
  'dissolved-magnesium': {
    analyte: 'dissolved-magnesium',
    name: 'Magnesium',
    unit: 'g/m³',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  'dissolved-manganese': {
    analyte: 'dissolved-manganese',
    name: 'Manganese',
    unit: 'g/m³',
    default: true,
    color: '#f2a900',
  } as AnalyteConfig,
  'dissolved-nickel': {
    analyte: 'dissolved-nickel',
    name: 'Nickel',
    unit: 'g/m³',
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'nitrate-+-nitrite-nitrogen': {
    analyte: 'nitrate-+-nitrite-nitrogen',
    name: 'Nitrate Nitrogen',
    unit: 'g/m³',
    default: true,
    color: '#26312b',
  } as AnalyteConfig,
  'dissolved-potassium': {
    analyte: 'dissolved-potassium',
    name: 'Potassium',
    unit: 'g/m³',
    default: true,
    color: '#00b1d8',
  } as AnalyteConfig,
  'total-sodium': {
    analyte: 'total-sodium',
    name: 'Sodium',
    unit: 'g/m³',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  sulphate: {
    analyte: 'sulphate',
    name: 'Sulphate',
    unit: 'g/m³',
    default: true,
    color: '#f2a900',
  } as AnalyteConfig,
  'total-boron': {
    analyte: 'total-boron',
    name: 'Boron',
    unit: 'g/m³',
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'total-calcium': {
    analyte: 'total-calcium',
    name: 'Calcium',
    unit: 'g/m³',
    default: true,
    color: '#26312b',
  } as AnalyteConfig,
  chloride: {
    analyte: 'chloride',
    name: 'Chloride',
    unit: 'g/m³',
    default: true,
    color: '#00b1d8',
  } as AnalyteConfig,
  'total-ammoniacal-nitrogen': {
    analyte: 'total-ammoniacal-nitrogen',
    name: 'Total Ammoniacal Nitrogen',
    unit: 'g/m³',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  'total-hardness': {
    analyte: 'total-hardness',
    name: 'Total Hardness',
    unit: 'g/m³',
    default: true,
    color: '#f2a900',
  } as AnalyteConfig,
  'bicarbonate-at-25-degrees-c': {
    analyte: 'bicarbonate-at-25-degrees-c',
    name: 'Bicarbonate',
    unit: 'g/m³',
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'sum-of-anions': {
    analyte: 'sum-of-anions',
    name: 'Sum of Anions',
    unit: 'g/m³',
    default: true,
    color: '#26312b',
  } as AnalyteConfig,
  'sum-of-cations': {
    analyte: 'sum-of-cations',
    name: 'Sum of Cations',
    unit: 'g/m³',
    default: true,
    color: '#00b1d8',
  } as AnalyteConfig,
  'relative-water-level': {
    analyte: 'relative-water-level',
    name: 'Relative Water Level',
    unit: 'm',
    default: true,
    color: '#66c39b',
  } as AnalyteConfig,
  'relative-water-level-mm': {
    analyte: 'relative-water-level-mm',
    name: 'Relative Water Level',
    unit: 'mm',
    default: true,
    color: '#66c39b',
  } as AnalyteConfig,
  'River flow': {
    analyte: 'River flow',
    name: 'River Flow',
    unit: 'm³/s',
    default: true,
    color: '#6691c3',
  } as AnalyteConfig,
  flow: {
    analyte: 'flow',
    name: 'Flow',
    unit: 'm³/s',
    default: true,
    color: '#6691c3',
  } as AnalyteConfig,
  precipitation: {
    analyte: 'precipitation',
    name: 'Rainfall',
    unit: 'mm',
    default: true,
    color: '#00b1d8',
    inverse: true,
  } as AnalyteConfig,
  'e.-coli': {
    analyte: 'e.-coli',
    name: 'E. coli',
    unit: 'cfu/100ml',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  'electrical-conductivity-in-field': {
    analyte: 'electrical-conductivity-in-field',
    name: 'Electrical Conductivity (field)',
    unit: 'mS/m',
    default: true,
    color: '#f26b4b',
  } as AnalyteConfig,
  'stream-flow': {
    analyte: 'stream-flow',
    name: 'Stream Flow',
    unit: 'L/s',
    default: true,
    color: '#26312b',
  } as AnalyteConfig,
  'total-suspended-solids': {
    analyte: 'total-suspended-solids',
    name: 'Total Suspended Solids',
    unit: 'g/m³',
    default: true,
    color: '#00b1d8',
  } as AnalyteConfig,
  'biochemical-oxygen-on-demand': {
    analyte: 'biochemical-oxygen-on-demand',
    name: 'BOD as O2',
    unit: 'g/m³',
    default: true,
    color: '#8c7ebb',
  } as AnalyteConfig,
  'dissolved-oxygen-saturation-in-field': {
    analyte: 'dissolved-oxygen-saturation-in-field',
    name: 'Dissolved Oxygen Saturation',
    unit: '%',
    default: true,
    color: '#f2a900',
  } as AnalyteConfig,
  'total-nitrogen': {
    analyte: 'Total Nitrogen',
    name: 'Total Nitrogen',
    unit: 'g/m³',
    default: true,
    color: '#88bb7e',
  } as AnalyteConfig,
  'Total Nitrogen': {
    /* duplicate */ analyte: 'Total Nitrogen',
    name: 'Total Nitrogen',
    unit: 'g/m³',
    default: true,
    color: '#88bb7e',
  } as AnalyteConfig,
  'dissolved-reactive-phosphorous': {
    analyte: 'dissolved-reactive-phosphorous',
    name: 'Dissolved Reactive Phosphorous',
    unit: 'g/m³',
    default: true,
    color: '#bbaf7e',
  } as AnalyteConfig,
};
